module.exports = __webpack_public_path__ + "VIPS4.png?ec31918838ac179a90b4b060072c2c27";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/speedway/VIPS4.png
// module id = 158
// module chunks = 0